const PICKER_SELECTOR = 'variant-picker[data-size-required-3dids]';

function findPicker(productForm) {
  const { sectionId, productId } = productForm.dataset;
  return document.querySelector(
    `${PICKER_SELECTOR}[data-section-id="${sectionId}"][data-product-id="${productId}"]`
  );
}

function isMissingSize(picker) {
  return [...picker.querySelectorAll('fieldset.variant-option')].some(
    (fieldset) => !fieldset.querySelector('input:checked')
  );
}

function guard(event) {
  const target = event.target;
  if (!(target instanceof Element)) return;

  if (event.type === 'click' && !target.closest('button[type="submit"]')) return;

  const productForm = target.closest('product-form-component');
  if (!productForm) return;

  const picker = findPicker(productForm);
  if (!picker || !isMissingSize(picker)) return;

  event.preventDefault();
  event.stopImmediatePropagation();

  const error = picker.querySelector('.variant-picker__error-3dids');
  if (error) error.hidden = false;
}

if (!window.__sizeRequired3dids) {
  window.__sizeRequired3dids = true;

  window.addEventListener('click', guard, true);
  window.addEventListener('submit', guard, true);

  document.addEventListener('change', (event) => {
    const target = event.target;
    if (!(target instanceof HTMLInputElement)) return;

    const picker = target.closest(PICKER_SELECTOR);
    const error = picker?.querySelector('.variant-picker__error-3dids');
    if (error) error.hidden = true;
  });
}
